module.exports = __webpack_public_path__ + "b74fac42547b099d4d9868c267b5e8f7.jpg";